const  accordian = {
    accordian: document.querySelectorAll('.jsAccordian'),

   
    init() {       
        this.toggle();      
  
    },

    toggle() {    
   
        this.accordian.forEach((item) => {
            if( window.innerWidth < parseInt(item.dataset.width) ) {
                if (item.dataset.open === 'true') { 
                    item.parentElement.style.maxHeight =  item.offsetHeight + item.nextElementSibling.offsetHeight + 'px';
                    item.lastElementChild.style.transform = 'rotate(180deg)';
                } 
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                  
                    if (item.dataset.open === 'false') {
                    
                        item.dataset.open = 'true';
                        item.parentElement.style.maxHeight =  item.offsetHeight + item.nextElementSibling.offsetHeight + 'px';
                        item.lastElementChild.style.transform = 'rotate(180deg)';
                    } else {
                        item.dataset.open = 'false';
                        item.parentElement.style.maxHeight = item.offsetHeight + 'px';
                        item.lastElementChild.style.transform = 'rotate(0deg)';
                    }
                });
            }
          
        });
      
    },

}

export default  accordian;